import { answeredMapper, calidadDatosMapper, invalidMapper, porcRespuestasMapper } from "../dashHelper"
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar, radialMapperByIndicator } from "../widgetsLibrary/widgetsLine"
import { commonWidgets, getCmID, getJacCustomerJourneyVentaWidget, jacCustomerJourneyMapper, jacGaugeCountNumberMapper, 
    getJacNpsVentaWidget, getJacCalidadDatosWidget, getJacPorcRespuestasWidget, jacGaugeCount10NumberMapper,
    ventaMapperJacCustomerJourney, getJacCustomerJourney } from "./commonWidgetsJac"

export default {
  title: "Demo Venta Dashboard",
  description: "Demo de Nacional Venta",
  backgroundClassName: (filters: any) => {
    return 'epsilon-hero-bg'
  },
  widgets: (filters: FiltersUI) => [
    getLineDetailedRadar({
      mainIndicator: 'VENTA_CSAT',
      radialIndicators: [
        'VENTA_RECEPCION',
        'VENTA_ATENCION',
        'VENTA_EXPLICACION',
        'VENTA_INSTALACIONES',
        'VENTA_ENTREGA'
      ],
      radialType: 'byIndicator',
      size: [4, 3],
      title: 'widgets.snByGeo',
      criticalMomentInclude: [getCmID('venta')],
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        maxValue: 100,
      },
      extras: {
        //formula: 'nps-10'
      },
      groupByLevel: 2,
      useNormalizedRadial: false,
      indicatorsNames: {
        'VENTA_RECEPCION': 'Recepción',
        'VENTA_ATENCION': 'Atención y amabilidad',
        'VENTA_EXPLICACION': 'Conocimiento',
        'VENTA_INSTALACIONES': 'Instalaciones',
        'VENTA_ENTREGA': 'Entrega',
      },
    }),
    //1
    {
      title: 'Mensual',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    {
      title: 'Semanal',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyLineTrendByMonth',
      title: 'Encuestas/Alertas por mes',
      size: [2, 2],
      criticalMomentInclude: [getCmID('venta')],
      extras: {
        eriods: 6,
      }
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyLineTrendByWeek',
      title: 'Encuestas/Alertas por semana',
      size: [2, 2],
      criticalMomentInclude: [getCmID('venta')],

    }),

    getJacNpsVentaWidget(),
    getJacCalidadDatosWidget(getCmID('venta')),
    getJacPorcRespuestasWidget(getCmID('venta')),
   // getJacCustomerJourneyVentaWidget(),
   
   getJacCustomerJourney({
       id: 'multipleGaugeByQuestion',
       title: 'widgets.customerJourneyVenta',
       helpText: '',
       size: [4, 2],
       mapper: ventaMapperJacCustomerJourney,
       extraConfigs: {
         chartRadius: '80%',
         chartCenter: ['50%', '45%'],
         labelFontSize: 40,
         groupNameFormat: 'description',
         maxValue: 100,
         colors: undefined
       },
       indicators: [
         { name: 'VENTA_RECEPCION', formula: 'count-number' },
         { name: 'VENTA_ATENCION', formula: 'count-number' },
         { name: 'VENTA_EXPLICACION', formula: 'count-number' },
         { name: 'VENTA_INSTALACIONES', formula: 'count-number' },
         { name: 'VENTA_ENTREGA', formula: 'count-number' }
       ],
     }),
    
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestRotativasVenta',
      size: [2, 1],
      indicator: 'SENTIMENT',
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstRotativasVenta',
      size: [2, 1],
      indicator: 'SENTIMENT',
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'Mapa de estaciones',
      size: [2, 2],
      indicator: 'VENTA_CSAT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76'
      },
      indicator: 'VENTA_CSAT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476'
      },
      indicator: 'VENTA_CSAT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'widgets.wordCount',
      size: [4, 2],
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'widgets.ishikawa',
      size: [4, 2],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('venta')],
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: "widgets.sentimentAnalysis",
      size: [4, 3],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    {
      title: 'widgets.otherIndicators',
      type: 'label',
      size: [4, 1]
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'jacGaugeSingleton',
      title: 'Recepción',
      size: [1, 2],
      indicator: 'VENTA_RECEPCION',
      helpText: '¿Qué tan satisfecho estás con el proceso de recepción que te brindo la agencia?',
      extras: {
        formula: 'count-number'
      },
      mapper: jacGaugeCount10NumberMapper,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'jacGaugeSingleton',
      title: 'Atención y amabilidad',
      size: [1, 2],
      indicator: 'VENTA_ATENCION',
      helpText: '¿Qué tan satisfecho estás con la atención y amabilidad que te brindo tu asesor?',
      extras: {
        formula: 'count-number'
      },
      mapper: jacGaugeCount10NumberMapper,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'jacGaugeSingleton',
      title: 'Conocimiento',
      size: [1, 2],
      indicator: 'VENTA_EXPLICACION',
      helpText: '¿Qué tan satisfecho estás con el conocimiento de tu asesor?',
      extras: {
        formula: 'count-number'
      },
      mapper: jacGaugeCount10NumberMapper,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'jacGaugeSingleton',
      title: 'Instalaciones',
      size: [1, 2],
      indicator: 'VENTA_INSTALACIONES',
      helpText: '¿Qué tan satisfecho estás con las instalaciones de la JAC Store durante tus visitas?',
      extras: {
        formula: 'count-number'
      },
      mapper: jacGaugeCount10NumberMapper,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'jacGaugeSingleton',
      title: 'Entrega',
      size: [1, 2],
      indicator: 'VENTA_ENTREGA',
      helpText: '¿Qué tan satisfecho estás con la experiencia de entrega de tu vehículo JAC?',
      extras: {
        formula: 'count-number'
      },
      mapper: jacGaugeCount10NumberMapper,
    })
    
  ],
} as DasboardConfig
